import axios from "axios";
import BaseService from "./BaseService";

export default {
  validate(creds) {
    return axios
      .post(`${BaseService.apiUrl()}/v1/passwords/validate`, creds)
      .then(data => data.data)
      .catch(() => Promise.reject());
  }
};
